import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  panelAppearanceRowClassName,
  panelColorSwatchClassName,
  panelRowLabelClassName,
} from '../propertyPanelUtils';

type ColorFieldProps = {
  label?: string;
  value: string;
  mixed?: boolean;
  mixedLabel?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
};

const ColorField: React.FC<ColorFieldProps> = ({
  label,
  value,
  mixed = false,
  mixedLabel,
  onChange,
  onBlur,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('common.color');
  const resolvedMixedLabel = mixedLabel ?? t('common.mixed');

  return (
    <div className={panelAppearanceRowClassName}>
      <div className={panelRowLabelClassName}>{resolvedLabel}</div>
      <div className="flex flex-col items-end gap-1">
        {mixed && (
          <div className="text-[11px] text-gray-400">{resolvedMixedLabel}</div>
        )}
        <input
          className={panelColorSwatchClassName}
          type="color"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onBlur}
          disabled={disabled}
          aria-label={resolvedLabel}
        />
      </div>
    </div>
  );
};

export default ColorField;
